import { BuildEnv } from '../config/env-config';

export const getRuntimeEnv = (buildEnv: BuildEnv) => {
  return {
    isProd: buildEnv === '',
    isLowerRegionEnv: buildEnv !== '' && buildEnv !== 'sandbox',
  };
};
